import './ConsentText.scss';

export const ConsentText = () => {
  return (
    <div className="srf-comments-consent-text">
      Mit dem Absenden dieses Kommentars stimme ich der&nbsp;
      <a
        className="srf-comments-header-text__link"
        rel="noopener noreferrer"
        target="_blank"
        href="https://www.srf.ch/hilfe/rechtliches/netiquette-und-user-generated-content-ugc">
        Netiquette
      </a>
      &nbsp;von srf.ch zu. Bei der Prüfung des Kommentars kann unterstützend
      Künstliche Intelligenz verwendet werden.
    </div>
  );
};
